// src/pages/Contact.jsx
import { useState } from 'react';
import SectionTitle from '../components/common/SectionTitle';
import Button from '../components/common/Button';
import contactBg from '../Assets/TeamandOthers/Reception.webp'

const branches = [
  {
    city: "Vijayawada",
    phone: "+91 9490 948081",
    address: "Near Vijaya Talkies, Eluru Road, Vijayawada",
  },
  {
    city: "Hyderabad (KPHB)",
    phone: "+91 8121 222 666",
    address: "Plot No. 123, Road No. 1, KPHB Colony",
  },
  {
    city: "Hyderabad (Nallagandla)",
    phone: "+91 95420 27700",
    address: "Near Lingampally Railway Station",
  },
  {
    city: "Hyderabad (Ameerpet)",
    phone: "+91 8121 666 111",
    address: "Above HDFC Bank, Ameerpet",
  },

];

const Contact = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      alert("Thank you! Your message has been sent. We'll get back to you soon.");
      e.target.reset();
    }, 1500);
  };

  return (
    <main className="min-h-screen">
      {/* Hero Section */}
      <section
        className="relative text-white py-20 md:py-28 bg-cover bg-center "
        style={{ backgroundImage: `url(${contactBg})` }}
      >
        {/* overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        <div className="relative container mx-auto px-5 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight">
            Get in Touch with Us
          </h1>
          <p className="text-lg md:text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
            We're here to help you achieve the confident smile you deserve. Reach out today!
          </p>
        </div>
      </section>


      {/* Main Contact Section */}
      <section className="py-16 md:py-20 bg-gray-50">
        <div className="container mx-auto px-5 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-stretch">
            {/* Left: Contact Form */}
            <div className="bg-white rounded-2xl shadow-xl shadow-blue-100/30 border border-gray-100 overflow-hidden">
              <div className="p-8 md:p-10 lg:p-12">
                <SectionTitle
                  title="Send Us a Message"
                  subtitle="We'll respond within 24 hours"
                  className="mb-10 text-center"
                />

                <form onSubmit={handleSubmit} className="space-y-6 flex flex-col">
                  {/* Name */}
                  <div className="relative">
                    <input
                      type="text"
                      id="name"
                      required
                      placeholder=""
                      className="peer w-full px-5 py-4 border border-gray-300 rounded-xl 
  focus:border-blue-500 focus:ring-1 focus:ring-blue-200 focus:outline-none 
  transition-all duration-200 bg-white text-gray-900"
                    />

                    <label
                      htmlFor="name"
                      className="
    absolute left-5 top-4 text-gray-500 text-base
    transition-all duration-200
    peer-focus:hidden
    peer-valid:hidden
    pointer-events-none
  "
                    >

                      Full Name *
                    </label>
                  </div>

                  {/* Email */}
                  <div className="relative">
                    <input
                      type="email"
                      id="email"
                      required
                      placeholder=" "
                      pattern="^[^\s@]+@[^\s@]+\.[^\s@]{2,}$"
                      title="Enter a valid email (example: abc@gmail.com)"
                      className="peer w-full px-5 py-4 border border-gray-300 rounded-xl 
  focus:border-blue-500 focus:ring-1 focus:ring-blue-200 focus:outline-none 
  transition-all duration-200 bg-white text-gray-900"
                    />

                    <label
                      htmlFor="email"
                      className="
    absolute left-5 top-4 text-gray-500 text-base
    transition-all duration-200
    peer-focus:hidden
    peer-[&:not(:placeholder-shown)]:hidden
    pointer-events-none
  "
                    >
                      Email Address *
                    </label>

                  </div>


                  {/* Phone */}
                  <div className="relative">
                    <input
                      type="tel"
                      id="phone"
                      required
                      maxLength={10}
                      pattern="[0-9]{10}"
                      inputMode="numeric"
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                      }}
                      className="peer w-full px-5 py-4 border border-gray-300 rounded-xl 
    focus:border-blue-500 focus:ring-1 focus:ring-blue-200 focus:outline-none 
    transition-all duration-200 bg-white text-gray-900"
                    />
                    <label
                      htmlFor="phone"
                      className="
      absolute left-5 top-4 text-gray-500 text-base
      transition-all duration-200
      peer-focus:hidden
      peer-valid:hidden
      pointer-events-none
    "
                    >
                      Phone Number *
                    </label>
                  </div>


                  {/* Message */}
                  <div className="relative flex-grow">
                    <textarea
                      id="message"
                      rows={3}
                      placeholder=" "
                      className="peer w-full px-5 py-4 border border-gray-300 rounded-xl 
  focus:border-blue-500 focus:ring-1 focus:ring-blue-200 focus:outline-none 
  transition-all duration-200 bg-white resize-none text-gray-900"
                    />
                    <label
                      htmlFor="message"
                      className="
    absolute left-5 top-4 text-gray-500 text-base
    transition-all duration-200
    peer-focus:hidden
    peer-not-placeholder-shown:hidden
    pointer-events-none
  "
                    >
                      Your Message
                    </label>
                  </div>

                  {/* Submit Button */}
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full py-4 text-lg font-semibold rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-3 mt-2"
                  >
                    {isSubmitting ? (
                      <>
                        <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                        </svg>
                        Sending...
                      </>
                    ) : (
                      "Send Message"
                    )}
                  </Button>
                </form>
              </div>
            </div>

            {/* Right: Branches Info */}
            <div className="bg-white rounded-2xl shadow-xl shadow-blue-100/30 border border-gray-100 overflow-hidden flex flex-col">
              <div className="p-8 md:p-10 lg:p-12 flex-grow">
                <SectionTitle
                  title="Our Locations"
                  subtitle="Visit us at any of our branches"
                  className="mb-10 text-center"
                />

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-6">
                  {branches.map((branch, i) => (
                    <div
                      key={i}
                      className="bg-blue-50/50 p-6 rounded-xl hover:bg-blue-100/50 transition-all duration-300 flex flex-col justify-between border border-blue-100"
                    >
                      <div>
                        <h3 className="text-xl font-bold text-blue-800 mb-3">{branch.city}</h3>
                        <p className="text-gray-700 text-base mb-2">
                          <span className="font-medium">Address:</span> {branch.address}
                        </p>
                      </div>
                      <p className="text-blue-600 font-semibold text-lg mt-3">
                        📞 {branch.phone}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Optional extra info at bottom */}
              <div className="bg-blue-600 text-white p-6 text-center">
                <p className="font-medium">
                  Working Hours: Mon–Sat 9 AM – 9 PM
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;